import { render } from "./banner.vue?vue&type=template&id=6979916f&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=6979916f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6979916f"

export default script